import { CommonModule }              from '@angular/common';
import { NgModule }                  from '@angular/core';
import { NgbDropdownModule }         from '@ng-bootstrap/ng-bootstrap';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';


@NgModule( {
	declarations: [
		LanguageSelectorComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Third Party
		NgbDropdownModule
	],
	exports: [
		// Language
		LanguageSelectorComponent
	]
} )
export class LanguageSelectorModule {}
